import { render, staticRenderFns } from "./new_trusteeshio_msg.vue?vue&type=template&id=50e611bf&scoped=true&"
import script from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
export * from "./new_trusteeshio_msg.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeshio_msg.vue?vue&type=style&index=0&id=50e611bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e611bf",
  null
  
)

export default component.exports